// SAME DAY, WHEN THE FORM CANNOT TAKE IT (17 Oct 2026). Robin: "and lets try
// your options on same day". A customer who wants today and cannot have it
// on the form (the day was moved: "That day isn't available, so we've moved
// it to tomorrow", or today is past the cutoff) is offered WhatsApp, where
// the team can try to fit them in. Shown under the day chips while Today is
// chosen too. Replays 01a11c81, 01a122ae (moved) and 01a14880 (Today +£25,
// gone 16 s later).
//
// Pure, so it runs under node --test (same-day-offer.test.mjs). No em dashes.

export const SAME_DAY_OFFER = "Need it today? WhatsApp us and we'll try to fit you in"

// What the same-day surcharge is called wherever it shows (the Today chip,
// the line under the total, the phone bar).
export const SAME_DAY_LABEL = 'Same-day priority'

// "SW6" from "SW6 1RE", "sw61re" or a typed "SW6"; null when there is no
// postcode to read.
export const outwardCode = postcode => {
  const t = String(postcode || '').toUpperCase().replace(/\s+/g, '')
  const m = t.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})?$/)
  return m ? m[1] : null
}

const article = word => (/^[AEIOU]/i.test(word) ? 'an' : 'a')

// "Hi, I'd like a Full Valet today in W11, is there any chance?"
export const sameDayWhatsappText = ({ wash, postcode } = {}) => {
  const what = wash ? `${article(wash)} ${wash}` : 'a wash'
  const where = outwardCode(postcode)
  return `Hi, I'd like ${what} today${where ? ` in ${where}` : ''}, is there any chance?`
}

// same_day_unavailable's reason for a day the form moved: 'too_late' when
// today was asked for after the same-day cutoff, 'moved' for any other day
// that could not be booked. ('full' is for a slot capacity check, which the
// booking form does not have yet.)
export const unavailableReason = ({ requestedToday }) => (requestedToday ? 'too_late' : 'moved')
